import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const ProektirovanieBrands = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },

    methods: {

    },
    updated(){

    },
    mounted(){

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS && this.struct[this.structKey].componentData.ITEMS.length" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Бренды для проектов {{this.struct[this.structKey].componentData.HEADER}}
                </h2>
            </div>
        </div>
        <div class="project-brands">

            <a v-for="item in this.struct[this.structKey].componentData.ITEMS" :href="item.LINK" class="clients__card" :class="{'no-photo': item.IMAGE === false}">
                <img v-if="item.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE" :alt="item.NAME" :title="item.NAME">
                <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
            </a>

        </div>
    </div>
</section>
    `
}